import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/styles';
import { TableRow, TableCell } from '@material-ui/core';

const useStyles = makeStyles({
  skeletonAction: {
    display: 'inline-flex',
    marginRight: '0.5rem'
  },
  tableRow: {
    cursor: 'pointer',
    '& td': {
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem'
    }
  }
});

const RowSkeleton = props => {
  const classes = useStyles();

  return (
    <TableRow className={classes.tableRow} row="checkbox" hover>
      <TableCell align="center">
        <Skeleton height={6} width={12} />
      </TableCell>
      <TableCell align="center">
        <Skeleton height={48} width={48} />
      </TableCell>
      <TableCell>
        <Skeleton height={6} width="50%" />
      </TableCell>

      {props.selectedFiles && <TableCell></TableCell>}
      <TableCell>
        <Skeleton height={6} width={18} />
      </TableCell>
      <TableCell align="right">
        <Skeleton
          className={classes.skeletonAction}
          variant="circle"
          height={24}
          width={24}
        />
      </TableCell>
    </TableRow>
  );
};

export default RowSkeleton;
